import { Controller } from "@hotwired/stimulus"

// Two-way sync between tier pills and number inputs for guest count and budget.
export default class extends Controller {
  static targets = ["guestPills", "budgetPills", "guestInput", "budgetInput"]

  selectTier(event) {
    const btn = event.currentTarget
    const field = btn.dataset.field
    const value = btn.dataset.value

    if (field === 'guest') {
      this.setGuestValue(value)
      this.highlightPill(btn, this.element.querySelectorAll('[data-field="guest"]'))
    } else if (field === 'budget') {
      this.setBudgetValue(value)
      this.highlightPill(btn, this.element.querySelectorAll('[data-field="budget"]'))
    }
  }

  setGuestValue(value) {
    if (this.hasGuestInputTarget) {
      this.guestInputTarget.value = value
      this.guestInputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }

  setBudgetValue(value) {
    if (this.hasBudgetInputTarget) {
      this.budgetInputTarget.value = value
      this.budgetInputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }

  syncGuestPill() {
    const value = parseInt(this.guestInputTarget.value)
    const pills = this.element.querySelectorAll('[data-field="guest"]')
    pills.forEach(pill => pill.classList.remove('border-teal-500', 'bg-teal-100', 'text-teal-700'))
    if (!value) return

    const tiers = [
      { max: 30, el: pills[0] },
      { max: 80, el: pills[1] },
      { max: 150, el: pills[2] },
      { max: 300, el: pills[3] },
      { max: Infinity, el: pills[4] },
    ]
    const matched = tiers.find(t => value <= t.max)
    if (matched && matched.el) this.highlightPill(matched.el, pills)
  }

  syncBudgetPill() {
    const value = parseInt(this.budgetInputTarget.value)
    const pills = this.element.querySelectorAll('[data-field="budget"]')
    pills.forEach(pill => pill.classList.remove('border-coral-500', 'bg-coral-100', 'text-coral-700'))
    if (!value) return

    const tiers = [
      { max: 49999,   el: pills[0] },
      { max: 149999,  el: pills[1] },
      { max: 499999,  el: pills[2] },
      { max: Infinity, el: pills[3] },
    ]
    const matched = tiers.find(t => value <= t.max)
    if (matched && matched.el) this.highlightBudgetPill(matched.el, pills)
  }

  highlightPill(activePill, allPills) {
    allPills.forEach(pill => {
      pill.classList.remove('border-teal-500', 'bg-teal-100', 'text-teal-700', 'border-gray-200', 'bg-gray-50')
      pill.classList.add('border-gray-200', 'bg-gray-50')
    })
    activePill.classList.remove('border-gray-200', 'bg-gray-50')
    activePill.classList.add('border-teal-500', 'bg-teal-100', 'text-teal-700')
  }

  highlightBudgetPill(activePill, allPills) {
    allPills.forEach(pill => {
      pill.classList.remove('border-coral-500', 'bg-coral-100', 'text-coral-700', 'border-gray-200', 'bg-gray-50')
      pill.classList.add('border-gray-200', 'bg-gray-50')
    })
    activePill.classList.remove('border-gray-200', 'bg-gray-50')
    activePill.classList.add('border-coral-500', 'bg-coral-100', 'text-coral-700')
  }
}
